import { Box } from '@zillow/constellation-10';

import { VIEW_TYPE } from './constants';

import { containerRecipe, desktopContainerRecipe, mobileContainerRecipe } from './styles';

import { WizardTip } from './WizardTip';
import { WizardTipCard } from './WizardTipCard';

import type React from 'react';
import type { PageWizardProps } from '../Wizard/PageWizard';

type Props = {
  header: string;
  showDesktopViewBreakpoint: PageWizardProps['showDesktopViewBreakpoint'];
  children: React.ReactNode;
  icon?: React.ReactNode;
  isPremiumTip?: boolean;
};

const WizardTipCardContainer = ({ header, showDesktopViewBreakpoint, children, icon = null, isPremiumTip }: Props) => {
  return (
    <aside aria-labelledby="tip-title">
      <Box css={containerRecipe.raw({ showDesktopViewBreakpoint })}>
        <Box css={mobileContainerRecipe.raw({ showDesktopViewBreakpoint })}>
          {isPremiumTip ? (
            <WizardTip viewType={VIEW_TYPE.CARD}>
              <WizardTipCard header={header} isPremiumTip={isPremiumTip}>
                {children}
              </WizardTipCard>
            </WizardTip>
          ) : (
            <WizardTip header={header} viewType={VIEW_TYPE.ACCORDION}>
              {children}
            </WizardTip>
          )}
        </Box>

        <Box css={desktopContainerRecipe.raw({ showDesktopViewBreakpoint })}>
          <WizardTip viewType={VIEW_TYPE.CARD}>
            {icon ? (
              <WizardTipCard header={header} icon={icon}>
                {children}
              </WizardTipCard>
            ) : (
              <WizardTipCard header={header} isPremiumTip={isPremiumTip}>
                {children}
              </WizardTipCard>
            )}
          </WizardTip>
        </Box>
      </Box>
    </aside>
  );
};

export default WizardTipCardContainer;
